import theme from "../../styles/theme";

export const dataGridSx = {
  fontSize: '12px',
  color: theme.colors.grey[600],
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
  },
  '.MuiDataGrid-columnHeaders': {
    backgroundColor: theme.colors.mono.greyLight,
  },
  '.MuiTablePagination-displayedRows': {
    fontSize: '12px',
    color: theme.colors.mono.greyDarker,
  },
  // Remove bordas azuis quando em foco
  '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
    '&:focus': { outline: 'none' },
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  // Permite quebra de linha nos cabeçalhos
  '.MuiDataGrid-columnHeaderTitle': {
    whiteSpace: 'normal',
    lineHeight: '1.2',
  },
  // Permite quebra de linha nas células
  '.MuiDataGrid-cell': {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: '1.2',
  },
  // Remove o comportamento de texto com ...
  '.MuiDataGrid-cellContent': {
    whiteSpace: 'normal',
  },
};
